/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * Representation of a cost center. This bean is shallow, which means its potential relationship fields to other Org Unit fields are simple ids. No Org Unit WsDTO fields should be declared in this bean to avoid circular references.
 * @export
 * @interface B2BCostCenterShallow
 */
export interface B2BCostCenterShallow {
    /**
     * The original code of the cost center. Deprecated since 2005.
     * @type {string}
     * @memberof B2BCostCenterShallow
     * @deprecated
     */
    originalCode?: string;
    /**
     * The name of the cost center
     * @type {string}
     * @memberof B2BCostCenterShallow
     */
    name?: string;
    /**
     * Indication of whether the cost center is active. Deprecated since 2005. Read-only, used for display purposes.
     * @type {string}
     * @memberof B2BCostCenterShallow
     * @deprecated
     */
    active?: string;
    /**
     * Boolean flag of whether the cost center is active.
     * @type {boolean}
     * @memberof B2BCostCenterShallow
     */
    activeFlag?: boolean;
    /**
     * The code of the cost center
     * @type {string}
     * @memberof B2BCostCenterShallow
     */
    code?: string;
    /**
     * 
     * @type {Currency}
     * @memberof B2BCostCenterShallow
     */
    currency?: Currency;
}

/**
 * Check if a given object implements the B2BCostCenterShallow interface.
 */
export function instanceOfB2BCostCenterShallow(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function B2BCostCenterShallowFromJSON(json: any): B2BCostCenterShallow {
    return B2BCostCenterShallowFromJSONTyped(json, false);
}

export function B2BCostCenterShallowFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BCostCenterShallow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'originalCode': !exists(json, 'originalCode') ? undefined : json['originalCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'activeFlag': !exists(json, 'activeFlag') ? undefined : json['activeFlag'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'currency': !exists(json, 'currency') ? undefined : CurrencyFromJSON(json['currency']),
    };
}

export function B2BCostCenterShallowToJSON(value?: B2BCostCenterShallow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'originalCode': value.originalCode,
        'name': value.name,
        'active': value.active,
        'activeFlag': value.activeFlag,
        'code': value.code,
        'currency': CurrencyToJSON(value.currency),
    };
}

